import { IIconBase } from '..'

const atribuirIcon = ({
  color = '#333752',
  height = 14,
  width = 14,
}: IIconBase) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 14 14'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M9.33268 5.24433V11.871C9.33268 12.7168 8.72602 13.0727 7.98518 12.6643L5.69269 11.3868C5.44769 11.2527 5.05101 11.2527 4.80601 11.3868L2.51351 12.6643C1.77268 13.0727 1.16602 12.7168 1.16602 11.871V5.24433C1.16602 4.24683 1.98267 3.43018 2.98017 3.43018H7.51852C8.51602 3.43018 9.33268 4.24683 9.33268 5.24433Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M12.8327 2.98066V9.60734C12.8327 10.4532 12.226 10.809 11.4852 10.4007L9.33268 9.199V5.244C9.33268 4.2465 8.51602 3.42984 7.51852 3.42984H4.66602V2.98066C4.66602 1.98316 5.48267 1.1665 6.48017 1.1665H11.0185C12.016 1.1665 12.8327 1.98316 12.8327 2.98066Z'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M4.08398 7H6.41732'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M5.25 8.16683V5.8335'
        stroke={color}
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  )
}

export default atribuirIcon
